import axios from 'axios';
import store from './store';
import * as Sentry from '@sentry/browser';

const http = axios.create();

http.interceptors.request.use(config => {
  store.commit('START_LOADING');
  if (store.state.user && 
    store.state.user.signInUserSession &&
    store.state.user.signInUserSession.idToken &&
    store.state.user.signInUserSession.idToken.jwtToken &&
    !config.headers['X-Amz-Security-Token']) {
    config.headers['X-Amz-Security-Token'] = store.state.user.signInUserSession.idToken.jwtToken;
  }

  //console.log('http - config:', config);
  return config;
}, error => {
  store.commit('FINISH_LOADING');

    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      console.log('The request was made and the server responded with an error.');
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log('The request was made but no response was received.', error.request);
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message);
    }

  Sentry.captureException(error);
  return Promise.reject(error);
});

http.interceptors.response.use(response => {
  store.commit('FINISH_LOADING');
  // console.log('http - response:', response);
  return response;
}, error => {
  store.commit('FINISH_LOADING');

    if (error.response) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      console.log('The request was made and the server responded with an error.');
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log('The request was made but no response was received.', error.request);
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message);
    }

  Sentry.captureException(error);
  return Promise.reject(error);
});

export default http;
